/**
 * 定位当前城市 操作封装
 */
import {CITY_STORE_NAME} from '@/config/setting';

/**
 * 获取缓存的 当前城市
 */
export function getCity() {
    let city = localStorage.getItem(CITY_STORE_NAME);
    if (!city) {
        city = sessionStorage.getItem(CITY_STORE_NAME);
    }
    return JSON.parse(city);
}

/**
 * 缓存 当前城市
 * @param city 城市
 * @param remember 是否永久存储
 */
export function setCity(city, remember = false) {
    removeCity();
    if (Object.keys(city).length > 0) {
        if (remember) {
            localStorage.setItem(CITY_STORE_NAME, JSON.stringify(city));
        } else {
            sessionStorage.setItem(CITY_STORE_NAME, JSON.stringify(city));
        }
    }
}

/**
 * 移除 当前城市
 */
export function removeCity() {
    localStorage.removeItem(CITY_STORE_NAME);
    sessionStorage.removeItem(CITY_STORE_NAME);
}